module.exports = __webpack_public_path__ + "static/media/bkey-black.8b8dfa3d.svg";